import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

type ActivityStatus = 'overdue' | 'done' | 'in_progress'
export type ActivityType =
  | 'mapping'
  | 'mosaicking'
  | 'diagnosis'
  | 'pulverization'

interface Activity {
  activity_id: string
  range: { start: number; end: number }
  status: ActivityStatus
  type: ActivityType
}

interface DiagnosisActivity {
  id: string
  diagnosis_id?: string
  diagnosis_name: string
  area: number | null
  culture: Culture
  treatment: Treatment
  image_type: 'raw_images' | 'mosaic' | 'raw_images_geotag'
  activities: Activity[]
}

export interface GetActivitiesResponse {
  meta: {
    total: number
    currentPage: number
    next: number | null
    prev: number | null
  }
  results: DiagnosisActivity[]
}

interface GetActivitiesOptions {
  signal?: AbortSignal
}

interface GetActivitiesProps {
  start_date: string
  end_date: string
  page: number
}

export async function getActivities(
  { start_date, end_date, page }: GetActivitiesProps,
  { signal }: GetActivitiesOptions = {},
) {
  const { data } = await companiesApi.get<GetActivitiesResponse>(
    apiRoutes.getActivities,
    {
      signal,
      params: {
        start_date: start_date,
        end_date: end_date,
        page,
      },
    },
  )

  return data
}
